// Helpers de permisos tipo "seleccion" en el frontend.
//
// Para los de tipo "seleccion", `valor` es un
// array de ids permitidos.

// Id del permiso que restringe las Cajas Chicas (Banco con caja:true).

// Devuelve el array de ids permitidos (strings) para un permiso "seleccion", o
// null cuando NO hay restricción que aplicar.
//
// Regla (permisiva por defecto): solo restringe si el permiso está presente,
// activado y con una lista no vacía en `valor`. En cualquier otro caso (master
// tipo 0, permiso ausente, desactivado, o valor null/vacío) => null = "ve todo".
export const idsPermitidosSeleccion = (permisos, tipo, permisoId) => {
  if (tipo === 0 || !Array.isArray(permisos) || !permisoId) return null;
  const permiso = permisos.find(
    (p) => p.permisoId?.toString() === permisoId.toString()
  );
  if (!permiso || !permiso.activado) return null;
  if (!Array.isArray(permiso.valor) || permiso.valor.length === 0) return null;
  return permiso.valor.map((v) => v.toString());
};

// Para permisos tipo "monto": devuelve el monto máximo (Number) o null cuando NO
// hay límite (master tipo 0, permiso ausente, desactivado, o valor no numérico).
export const montoMaximoPermiso = (permisos, tipo, permisoId) => {
  if (tipo === 0 || !Array.isArray(permisos) || !permisoId) return null;
  const permiso = permisos.find(
    (p) => p.permisoId?.toString() === permisoId.toString()
  );
  if (!permiso || !permiso.activado) return null;
  if (typeof permiso.valor !== "number") return null;
  return permiso.valor;
};

// Filtra una lista de documentos { _id } dejando solo los de `ids`. Si `ids` es
// null (sin restricción), devuelve la lista intacta. `ids` normalmente proviene
// de idsPermitidosSeleccion(...) 
export const filtrarPorIds = (lista, ids) => {
  if (!ids) return lista || [];
  const permitidos = new Set(ids);
  return (lista || []).filter((item) => permitidos.has(item._id?.toString()));
};
